import { render } from "./zoom.vue?vue&type=template&id=8b8e3bdc"
import script from "./zoom.vue?vue&type=script&lang=js"
export * from "./zoom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/baptiste/P_8678-Amis-des-musees-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__